export default {
  businessLogisticsCompanyRelation: {
    header: {
      name: '业务名称',
      subordinateSubject: '所属主体',
      settlementMethod: '结算方式',
    },
    table: {
      name: '业务名称',
      associatedWarehouse: '关联仓库',
      subordinateSubject: '所属主体',
      settlementMethod: '结算方式',
      deliveryTime: '发货时间'
    },
    dialog: {
      name: '业务名称',
      namePlaceholder: '请先选择物流商名称',
      subordinateSubject: '所属主体',
      settlementMethod: '结算方式',
      deliveryTime: '发货时间',
      deliveryTimeBackend: '每日发货时间',
      associatedWarehouse: '关联仓库',
      associated: '已关联'
    },
    rules: {
      salesOrgId: '请选择所属主体',
      settlementMethod: '请选择结算方式',
      logisticsBusinessId: '请选择业务名称',
      logisticsCompanyId: '请选择物流商名称',
    }
  }
};
